'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var now = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    var _ref2, ISOString;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _methods.get)({
              url: '/api/now'
            });

          case 2:
            _ref2 = _context.sent;
            ISOString = _ref2.data.ISOString;
            return _context.abrupt('return', new Date(ISOString));

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function now() {
    return _ref.apply(this, arguments);
  };
}();

var _methods = require('./methods');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = now;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/codev-api/now.js
// module id = 1053
// module chunks = 0